import { Controller } from "@hotwired/stimulus"
import { recordProductSearchConversion } from "../src/search_conversion"

export default class extends Controller {
  static values = { query: String }

  connect() {
    this.element.querySelectorAll('[data-search-conversion]').forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this))
    })
  }

  handleClick(event) {
    const link = event.currentTarget
    const convertableType = link.dataset.searchConversionType
    const convertableId = link.dataset.searchConversionId

    if (convertableType === "Product" && convertableId) {
      recordProductSearchConversion(this.queryValue, convertableId)
    }
  }
}
